import { LOCATION_ORIGIN } from '../../../call-api';

export const LogoutMenuItem = {
  name: 'toolbar',
  items: [
    {
      order: 50,
      name: 'logout',
      text: 'Logout',
      ref: `${LOCATION_ORIGIN}/auth/logout`,
    },
  ],
};

// can have the following:
//    order     : number noting the order in which the item should appear
//    name      : string containing text for unique identifier (key)
//    text      : string containing text to display on menu link
//    ref       : string containing url for menu link
//    items     : array containing nested menu items of this same structure
//    style     : json obj w/ style info for list items in menu
export const FullMenu = [
  {
    order: 100,
    name: 'menu',
    // text: 'menu',
    items: [
      {
        order: 100,
        name: 'advocacy',
        text: 'Advocacy',
        ref: '/redirect/advocacy',
      },
      {
        order: 200,
        name: 'resources',
        text: 'Resources',
        ref: '/redirect/resources',
      },
      {
        order: 300,
        name: 'news',
        text: 'News',
        ref: '/redirect/news',
      },
      {
        order: 400,
        name: 'research',
        text: 'Research',
        ref: '/redirect/research',
      },
      {
        order: 500,
        name: 'legal-center',
        text: 'Legal Center',
        ref: '/redirect/legal-center',
      },
      {
        order: 600,
        name: 'member-benfits',
        text: 'Member Benefits',
        ref: '/redirect/member-benefits',
      },
    ],
  },
  {
    order: 200,
    name: 'toolbar',
    // text: 'toolbar',
    items: [
      {
        order: 100,
        name: 'why-nfib',
        text: 'Why NFIB?',
        ref: 'redirect/why-nfib',
      },
      {
        order: 200,
        name: 'join-now',
        text: 'Join Now',
        ref: 'redirect/join',
      },
      {
        order: 80,
        name: 'account',
        text: 'MyNFIB',
        ref: '/account',
      },
      {
        order: 90,
        name: 'events',
        text: 'Events',
        ref: '/events',
      },
    ],
  },
];

export default FullMenu;



// WEBPACK FOOTER //
// ./src/common/components/Layout/Header/MenuConfig.js